module.exports = __webpack_public_path__ + "static/media/javascript.4b48442d.svg";